import { useEffect, useRef } from 'react'
import { useMicVAD } from '@ricky0123/vad-react'

interface BargeInListenerProps {
    getStream: () => Promise<MediaStream>
    onBargeIn: () => void
    onBargeInAudio: (audio: Float32Array) => void
}

const BargeInListener: React.FC<BargeInListenerProps> = ({
    getStream,
    onBargeIn,
    onBargeInAudio,
}) => {
    const onBargeInRef = useRef(onBargeIn)
    onBargeInRef.current = onBargeIn

    const onBargeInAudioRef = useRef(onBargeInAudio)
    onBargeInAudioRef.current = onBargeInAudio

    const vad = useMicVAD({
        positiveSpeechThreshold: 0.5,
        redemptionMs: 1000,
        minSpeechMs: 200,
        startOnLoad: true,
        model: 'v5',
        baseAssetPath: '/',
        onnxWASMBasePath: '/',
        ortConfig: (ort) => {
            ort.env.wasm.numThreads = 1
        },
        getStream,
        // The mic stream is owned by useAudioRecorder, not this VAD instance —
        // the default pauseStream calls track.stop() on it, which would kill
        // the shared stream (and does so on every StrictMode dev double-mount).
        pauseStream: async () => {},
        resumeStream: getStream,
        onSpeechRealStart: () => onBargeInRef.current(),
        onSpeechEnd: (audio) => onBargeInAudioRef.current(audio),
        onVADMisfire: () => console.debug('[BargeInListener] VAD misfire, ignored'),
    })

    useEffect(() => {
        if (vad.errored) {
            console.error('[BargeInListener] Failed to initialize VAD', vad.errored)
        }
    }, [vad.errored])

    return null
}

export default BargeInListener
